import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './Benefits.css';

import Benefits1 from '../../assets/images/Benefits1.png';
import Benefits2 from '../../assets/images/Benefits2.png';
import Benefits3 from '../../assets/images/Benefits3.png';
import Benefits4 from '../../assets/images/Benefits4.png';

export default function Benefits() {
    return (
        <Container className="benefitsContainer worldwide" id="beneficii">
            <p className="benefitsTitle">{'<'}Beneficii{'/>'}</p>
            <Row className="text-center">
                <Col sm={12} lg={6} xxl={3} className="mb-4">
                    <div className="benefitsCard">
                        <div className="benefitsCardInner">
                            <div className="benefitsCardFront">
                                <div className="benefitsImageContainer">
                                    <img src={Benefits1} className="benefitsImage" alt="Service1"/>
                                    <p className="benefitsTextTop">
                                        <span className="benefitsTextTopButton1 animo">resurse</span>
                                    </p>
                                    <p className="benefitsTextBottom">
                                        <span>Materiale</span>
                                        <span>sintetizate</span>
                                    </p>
                                </div>
                            </div>
                            <div className="benefitsCardBack">
                                <p>
                                    De când lucrez cu elevii, am strâns o mulțime de materiale pentru a ușura procesul
                                    de învățare al materiei
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={12} lg={6} xxl={3} className="mb-4">
                    <div className="benefitsCard">
                        <div className="benefitsCardInner">
                            <div className="benefitsCardFront">
                                <div className="benefitsImageContainer">
                                    <img src={Benefits2} className="benefitsImage" alt="Service2"/>
                                    <p className="benefitsTextTop">
                                        <span className="benefitsTextTopButton2 animo">elevi</span>
                                    </p>
                                    <p className="benefitsTextBottom">
                                        <span>Școală, Bac</span>
                                        <span>& Admitere</span>
                                    </p>
                                </div>
                            </div>
                            <div className="benefitsCardBack">
                                <p>
                                    Pentru orice nivel te-ai pregăti, eu sunt aici să te ajut, să te îndrum și să-ți
                                    fiu un mentor în adevăratul sens al cuvântului
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={12} lg={6} xxl={3} className="mb-4">
                    <div className="benefitsCard">
                        <div className="benefitsCardInner">
                            <div className="benefitsCardFront">
                                <div className="benefitsImageContainer">
                                    <img src={Benefits3} className="benefitsImage" alt="Service3"/>
                                    <p className="benefitsTextTop">
                                        <span className="benefitsTextTopButton3 animo">profesori</span>
                                    </p>
                                    <p className="benefitsTextBottom" style={{marginLeft: "10px"}}>
                                        <span>Titularizare</span>
                                        <span>& Definitivat</span>
                                    </p>
                                </div>
                            </div>
                            <div className="benefitsCardBack">
                                <p>
                                    Primii pași în învățământ sunt, poate, cei mai grei. Totuși, încetul cu încetul
                                    putem clădi lucruri frumoase, împreună
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={12} lg={6} xxl={3} className="mb-4">
                    <div className="benefitsCard">
                        <div className="benefitsCardInner">
                            <div className="benefitsCardFront">
                                <div className="benefitsImageContainer">
                                    <img src={Benefits4} className="benefitsImage" alt="Service4"/>
                                    <p className="benefitsTextTop">
                                        <span className="benefitsTextTopButton4 animo">ajutor</span>
                                    </p>
                                    <p className="benefitsTextBottom" style={{marginLeft: "-10px"}}>
                                        <span>Suport</span>
                                        <span>permanent</span>
                                    </p>
                                </div>
                            </div>
                            <div className="benefitsCardBack">
                                <p>
                                    Oricând ai nevoie de ajutor, nu ezita să-l ceri. Eu sunt aici să te sprijin și
                                    să te ajut oricând ai nevoie de asta
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}